import React from 'react';
import AntBase from 'antd-core/es/typography/Base';

const Base = React.forwardRef((props, ref) => {
    return React.createElement(AntBase, Object.assign({ ref: ref }, props));
});

export { Base };
//# sourceMappingURL=Base.js.map
